module.exports = __webpack_public_path__ + "static/media/4ODA14.3e5e0840.jpg";